import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  searchBar: {
    width: '100%',
    minHeight: 0,
    marginBottom: 0
  },
  adornment: {
    paddingLeft: 10
  }
}));

export default useStyles;
